export default {
  'builderChat.newChat': 'New conversation',
  'builderChat.history': 'Conversation history',
  'builderChat.closeTab': 'Close tab',
  'builderChat.noTabs': 'No open conversations',
  'builderChat.untitledThread': 'Conversation #{number}',
  'builderChat.untitledFallback': 'Untitled',
  'builderChat.error': 'Could not initialize chat',
  'builderChat.noConnection': 'No connection. Try again.',
  'builderChat.errorCreatingNewChat': 'Could not create a new conversation',
  'builderChat.history.searchPlaceholder': 'Search conversation...',
  'builderChat.history.empty': 'No conversations in history',
  'builderChat.history.open': 'Already open',
  'builderChat.time.justNow': 'Just now',
  'builderChat.time.minutesAgo': '{n} min ago',
  'builderChat.time.hoursAgo': '{n} h ago',
  'builderChat.time.daysAgo': '{n} d ago',
  'builderChat.context.remove': 'Remove context',
  'builderChat.collapse': 'Hide chat',
  'builderChat.expand': 'Show chat',
  'builderChat.assistant': 'Asistente',
  'aiConsumption.title': 'AI usage',
  'aiConsumption.credits': 'Credits',
  'aiConsumption.cost': 'Cost',
  'aiConsumption.tokens': 'Tokens',
  'aiConsumption.requests': 'Requests',
  'aiConsumption.none': 'No usage recorded',
  'aiConsumption.scope.thread': 'This conversation',
  'aiConsumption.scope.total': 'Total',
  'aiConsumption.input': 'Input',
  'aiConsumption.output': 'Output',
  'aiConsumption.cache': 'Cache',
  'aiConsumption.tokensUnit': 'tokens',
};
